__turbopack_context__.v({
  "checkbox": "index-module-scss-module__s8_Ywq__checkbox",
  "checkbox-span": "index-module-scss-module__s8_Ywq__checkbox-span",
  "checked": "index-module-scss-module__s8_Ywq__checked",
});
